var isMergeableObject = function isMergeableObject(value) {
	return isNonNullObject(value)
		&& !isSpecial(value)
};

function isNonNullObject(value) {
	return !!value && typeof value === 'object'
}

function isSpecial(value) {
	var stringValue = Object.prototype.toString.call(value);

	return stringValue === '[object RegExp]'
		|| stringValue === '[object Date]'
		|| isReactElement(value)
}

// see https://github.com/facebook/react/blob/b5ac963fb791d1298e7f396236383bc955f916c1/src/isomorphic/classic/element/ReactElement.js#L21-L25
var canUseSymbol = typeof Symbol === 'function' && Symbol.for;
var REACT_ELEMENT_TYPE = canUseSymbol ? Symbol.for('react.element') : 0xeac7;

function isReactElement(value) {
	return value.$$typeof === REACT_ELEMENT_TYPE
}

function emptyTarget(val) {
	return Array.isArray(val) ? [] : {}
}

function cloneUnlessOtherwiseSpecified(value, options) {
	return (options.clone !== false && options.isMergeableObject(value))
		? deepmerge(emptyTarget(value), value, options)
		: value
}

function defaultArrayMerge(target, source, options) {
	return target.concat(source).map(function(element) {
		return cloneUnlessOtherwiseSpecified(element, options)
	})
}

function getMergeFunction(key, options) {
	if (!options.customMerge) {
		return deepmerge
	}
	var customMerge = options.customMerge(key);
	return typeof customMerge === 'function' ? customMerge : deepmerge
}

function getEnumerableOwnPropertySymbols(target) {
	return Object.getOwnPropertySymbols
		? Object.getOwnPropertySymbols(target).filter(function(symbol) {
			return target.propertyIsEnumerable(symbol)
		})
		: []
}

function getKeys(target) {
	return Object.keys(target).concat(getEnumerableOwnPropertySymbols(target))
}

function propertyIsOnObject(object, property) {
	try {
		return property in object
	} catch(_) {
		return false
	}
}

// Protects from prototype poisoning and unexpected merging up the prototype chain.
function propertyIsUnsafe(target, key) {
	return propertyIsOnObject(target, key) // Properties are safe to merge if they don't exist in the target yet,
		&& !(Object.hasOwnProperty.call(target, key) // unsafe if they exist up the prototype chain,
			&& Object.propertyIsEnumerable.call(target, key)) // and also unsafe if they're nonenumerable.
}

function mergeObject(target, source, options) {
	var destination = {};
	if (options.isMergeableObject(target)) {
		getKeys(target).forEach(function(key) {
			destination[key] = cloneUnlessOtherwiseSpecified(target[key], options);
		});
	}
	getKeys(source).forEach(function(key) {
		if (propertyIsUnsafe(target, key)) {
			return
		}

		if (propertyIsOnObject(target, key) && options.isMergeableObject(source[key])) {
			destination[key] = getMergeFunction(key, options)(target[key], source[key], options);
		} else {
			destination[key] = cloneUnlessOtherwiseSpecified(source[key], options);
		}
	});
	return destination
}

function deepmerge(target, source, options) {
	options = options || {};
	options.arrayMerge = options.arrayMerge || defaultArrayMerge;
	options.isMergeableObject = options.isMergeableObject || isMergeableObject;
	// cloneUnlessOtherwiseSpecified is added to `options` so that custom arrayMerge()
	// implementations can use it. The caller may not replace it.
	options.cloneUnlessOtherwiseSpecified = cloneUnlessOtherwiseSpecified;

	var sourceIsArray = Array.isArray(source);
	var targetIsArray = Array.isArray(target);
	var sourceAndTargetTypesMatch = sourceIsArray === targetIsArray;

	if (!sourceAndTargetTypesMatch) {
		return cloneUnlessOtherwiseSpecified(source, options)
	} else if (sourceIsArray) {
		return options.arrayMerge(target, source, options)
	} else {
		return mergeObject(target, source, options)
	}
}

deepmerge.all = function deepmergeAll(array, options) {
	if (!Array.isArray(array)) {
		throw new Error('first argument should be an array')
	}

	return array.reduce(function(prev, next) {
		return deepmerge(prev, next, options)
	}, {})
};

var deepmerge_1 = deepmerge;

var cjs = deepmerge_1;

function getRndInteger(min, max) {
    if (min > max)
        throw new Error("'min' must be less than 'max'");
    return Math.floor(Math.random() * (max - min + 1)) + min;
}
var nums = "1234567890".split('');
var letters = "abcdefghijklmnopqrstuvwxyz";
var specialChars = "-".split('');
var lowerCaseLetters = letters.split('');
var upperCaseLetters = letters.toUpperCase().split('');
var choices = nums.concat(lowerCaseLetters, upperCaseLetters, specialChars);
function randomString(length, prefix) {
    if (prefix === void 0) { prefix = ""; }
    if (length < prefix.length)
        throw new Error("'length' must not be less than the length of the prefix!");
    var getChar = function () { return choices[Math.floor(Math.random() * choices.length)]; };
    var chars = "";
    for (var cur = 0; cur < length - prefix.length; cur++) {
        chars += getChar();
    }
    return prefix + chars;
}
function getRightTriangleSides(hypotenuse, theta) {
    return {
        opposite: Math.sin(theta) * hypotenuse,
        adjacent: Math.cos(theta) * hypotenuse,
    };
}
function chooseOption(val) {
    if (Array.isArray(val)) {
        if (!val.length)
            throw new Error("Array cannot be empty");
        return val[getRndInteger(0, val.length - 1)];
    }
    else
        return val;
}

var defaultParticleOptions = {
    size: {
        max: 5,
        min: 3,
    },
    background: "#777",
    lifespan: {
        max: 5000,
        min: 4900,
    },
    speed: {
        min: 0.0003,
        max: 0.0004,
    },
    keepAround: false,
};

var Particle = /** @class */ (function () {
    function Particle(options) {
        this.callOnDestroy = [];
        this.callOnUpdate = [];
        this.addToExistingMultiplierX = Math.random() > 0.5 ? 1 : -1;
        this.addToExistingMultiplierY = Math.random() > 0.5 ? 1 : -1;
        this.options = cjs(defaultParticleOptions, options || {});
        this.id = randomString(20);
        this.positionX = this.options.startPositionX || Math.random();
        this.positionY = this.options.startPositionY || Math.random();
        this.initialPositionX = this.positionX;
        this.initialPositionY = this.positionY;
        this.age = 0;
        this.lifespan = getRndInteger(this.options.lifespan.min, this.options.lifespan.max);
        this.size = getRndInteger(this.options.size.min, this.options.size.max);
        this.speed = getRndInteger(this.options.speed.min, this.options.speed.max);
        this.background = chooseOption(this.options.background);
        this.setDestination();
    }
    Particle.prototype.triggerUpdate = function () {
        this.age++;
        if (this.age > this.lifespan) {
            if (!this.options.keepAround)
                return this.destroy();
            // Reset Position
            this.initialPositionX = this.positionX;
            this.initialPositionY = this.positionY;
            // Reset age
            this.age = 0;
            this.lifespan = getRndInteger(this.options.lifespan.min, this.options.lifespan.max);
            this.speed = getRndInteger(this.options.speed.min, this.options.speed.max);
            // Reset destination
            this.setDestination();
        }
        this.positionX = this.getNextPosition(this.initialPositionX, this.finalPositionX);
        this.positionY = this.getNextPosition(this.initialPositionY, this.finalPositionY);
        if (this.positionX > 1 || this.positionX < 0 || this.positionY > 1 || this.positionY < 0)
            return this.destroy();
        this.callOnUpdate.forEach(function (fn) { return fn(); });
    };
    Particle.prototype.destroy = function () {
        this.callOnDestroy.forEach(function (fn) { return fn(); });
    };
    Particle.prototype.onUpdate = function (fn) {
        this.callOnUpdate.push(fn);
    };
    Particle.prototype.onDestroy = function (fn) {
        this.callOnDestroy.push(fn);
    };
    Particle.prototype.setDestination = function () {
        var hypotenuse = this.lifespan * this.speed;
        var angle = getRndInteger(0, 90);
        var _a = getRightTriangleSides(hypotenuse, angle), adjacent = _a.adjacent, opposite = _a.opposite;
        this.finalPositionX = addToExisting(this.positionX, adjacent, this.addToExistingMultiplierX);
        this.finalPositionY = addToExisting(this.positionY, opposite, this.addToExistingMultiplierY);
        function addToExisting(pos, extra, multiplyer) {
            return pos + extra * multiplyer;
        }
    };
    Particle.prototype.getNextPosition = function (start, finish) {
        if (start === finish)
            return start;
        var difference = finish - start;
        var step = difference / this.lifespan;
        return start + step * this.age;
    };
    return Particle;
}());

var defaultConfig = {
    particlesCount: {
        max: 230,
        min: 200,
    },
    nextFrameCaller: function (fn) {
        setTimeout(fn, 16);
    },
    segments: true,
    segmentStrength: 0.11,
};

var defaultSegmentOptions = {
    stroke: "#bbb",
    width: {
        min: 0.5,
        max: 0.5,
    },
};

var Segment = /** @class */ (function () {
    function Segment(startParticle, endParticle, options) {
        var _this = this;
        this.callOnUpdate = [];
        this.callOnDestroy = [];
        var errBase = "The first param to 'Segment' ";
        if (!(startParticle instanceof Particle && endParticle instanceof Particle))
            throw new Error(errBase + "must be of type '[Particle, Particle]'");
        this.options = cjs(defaultSegmentOptions, options || {});
        this.startParticle = startParticle;
        this.endParticle = endParticle;
        this.stroke = chooseOption(this.options.stroke);
        this.width = getRndInteger(this.options.width.min, this.options.width.max);
        this.id = randomString(20);
        this.startParticle.onDestroy(function () { return _this.destroy(); });
        this.endParticle.onDestroy(function () { return _this.destroy(); });
    }
    Segment.prototype.triggerUpdate = function () {
        this.positionX1 = this.startParticle.positionX;
        this.positionX2 = this.endParticle.positionX;
        this.positionY1 = this.startParticle.positionY;
        this.positionY2 = this.endParticle.positionY;
        this.callOnUpdate.forEach(function (fn) { return fn(); });
    };
    Segment.prototype.destroy = function () {
        this.callOnDestroy.forEach(function (fn) { return fn(); });
    };
    Segment.prototype.onUpdate = function (fn) {
        this.callOnUpdate.push(fn);
    };
    Segment.prototype.onDestroy = function (fn) {
        this.callOnDestroy.push(fn);
    };
    return Segment;
}());

function loopFromIndex(array, startIndex, cb) {
    for (var x = startIndex; x < array.length; x++) {
        cb(array[x], x);
    }
}
function makePositive(n) {
    if (n < 0)
        return n * -1;
    return n;
}
function hypotenuse(n1, n2) {
    return Math.sqrt(n1 * n1 + n2 * n2);
}
function getDistanceBetween(particle1, particle2) {
    var distanceX = makePositive(particle1.positionX - particle2.positionX);
    var distanceY = makePositive(particle1.positionY - particle2.positionY);
    return hypotenuse(distanceX, distanceY);
}
var groupParticles = (function (particles, strength) {
    var result = [];
    particles.forEach(function (particle, index) {
        loopFromIndex(particles, index + 1, function (proposition) {
            var distanceBetween = getDistanceBetween(particle, proposition);
            if (distanceBetween <= strength)
                result.push([particle, proposition]);
        });
    });
    return result;
});

var DecentralizedParticles = /** @class */ (function () {
    function DecentralizedParticles(configOptions, particleOptions, segmentOptions) {
        this.particleCreator = function () { };
        this.segmentCreator = function () { };
        this.callBeforeUpdate = [];
        this.callAfterUpdate = [];
        this.intervalCounter = 20;
        this.config = cjs(this.config || defaultConfig, configOptions || {});
        this.particleOptions = particleOptions;
        if (this.config.segments)
            this.segmentOptions = segmentOptions;
        this.particleCreator = function () { };
    }
    DecentralizedParticles.prototype.createParticle = function (fn) {
        this.particleCreator = fn;
    };
    DecentralizedParticles.prototype.createSegment = function (fn) {
        this.segmentCreator = fn;
    };
    DecentralizedParticles.prototype.beforeUpdate = function (fn) {
        this.callBeforeUpdate.push(fn);
    };
    DecentralizedParticles.prototype.afterUpdate = function (fn) {
        this.callAfterUpdate.push(fn);
    };
    DecentralizedParticles.prototype.start = function () {
        var _this = this;
        this.currentState = this.createState();
        this.segments = new Map();
        this.currentState.forEach(function (particle) {
            _this.initParticle(particle);
            _this.listenForDestroy(particle);
        });
        this.triggerNextFrame();
    };
    DecentralizedParticles.prototype.pause = function () {
        var _this = this;
        var currentFrameCaller = this.config.nextFrameCaller;
        this.config.nextFrameCaller = function () { };
        return function () { return (_this.config.nextFrameCaller = currentFrameCaller); };
    };
    DecentralizedParticles.prototype.triggerNextFrame = function () {
        var _this = this;
        this.config.nextFrameCaller(function () { return _this.nextFrame(); });
    };
    DecentralizedParticles.prototype.nextFrame = function () {
        this.callBeforeUpdate.forEach(function (fn) { return fn(); });
        this.segments.forEach(function (segment) {
            segment.triggerUpdate();
        });
        this.currentState.forEach(function (particle) {
            particle.triggerUpdate();
        });
        this.callAfterUpdate.forEach(function (fn) { return fn(); });
        if (this.intervalCounter >= 20) {
            this.intervalCounter = 0;
            this.calculateSegments();
        }
        else {
            this.intervalCounter++;
        }
        this.triggerNextFrame();
    };
    DecentralizedParticles.prototype.initParticle = function (particle) {
        this.particleCreator(particle);
    };
    DecentralizedParticles.prototype.listenForDestroy = function (particle) {
        var _this = this;
        particle.onDestroy(function () {
            _this.currentState.delete(particle.id);
            _this.createReplacementParticles();
        });
    };
    DecentralizedParticles.prototype.createReplacementParticles = function () {
        var newAmountOfParticles;
        var _a = this.config.particlesCount, max = _a.max, min = _a.min;
        var count = this.currentState.size;
        if (max - min >= 5) {
            if (count >= max)
                newAmountOfParticles = 0;
            else if (count <= min)
                newAmountOfParticles = 2;
            else
                newAmountOfParticles = getRndInteger(0, 2);
        }
        else
            newAmountOfParticles = 1;
        for (var index = 0; index < newAmountOfParticles; index++) {
            var particle = new Particle(this.particleOptions);
            this.initParticle(particle);
            this.listenForDestroy(particle);
            this.currentState.set(particle.id, particle);
        }
    };
    DecentralizedParticles.prototype.calculateSegments = function () {
        var _this = this;
        var newSegments = new Map();
        groupParticles(Array.from(this.currentState).map(function (_a) {
            var _ = _a[0], particle = _a[1];
            return particle;
        }), this.config.segmentStrength).forEach(function (_a) {
            var startParticle = _a[0], endParticle = _a[1];
            var existingSegment;
            _this.segments.forEach(function (segment) {
                if (segment.startParticle.id === startParticle.id && segment.endParticle.id === endParticle.id) {
                    existingSegment = segment;
                }
            });
            if (existingSegment) {
                newSegments.set(existingSegment.id, existingSegment);
                _this.segments.delete(existingSegment.id);
            }
            else {
                var newSegment_1 = new Segment(startParticle, endParticle, _this.segmentOptions);
                newSegments.set(newSegment_1.id, newSegment_1);
                newSegment_1.onDestroy(function () {
                    _this.segments.delete(newSegment_1.id);
                });
                _this.segmentCreator(newSegment_1);
            }
        });
        this.segments.forEach(function (segment) {
            segment.destroy();
        });
        this.segments = newSegments;
    };
    DecentralizedParticles.prototype.createState = function () {
        var particleCount = getRndInteger(this.config.particlesCount.min, this.config.particlesCount.max);
        var particles = new Map();
        for (var index = 0; index < particleCount; index++) {
            var particle = new Particle(this.makeMinMoreRandom(this.particleOptions));
            particles.set(particle.id, particle);
        }
        return particles;
    };
    DecentralizedParticles.prototype.makeMinMoreRandom = function (options) {
        if (!options)
            options = {};
        if (!options.lifespan)
            options.lifespan = {};
        var oldVal = options.lifespan.min || defaultParticleOptions.lifespan.min;
        options.lifespan.min = getRndInteger(0, oldVal);
        return options;
    };
    return DecentralizedParticles;
}());

function createParticlesOnCanvas(element, configOptions, particleOptions, segmentOptions) {
    var ctx = element.getContext("2d");
    var width = function () { return element.clientWidth; };
    var height = function () { return element.clientHeight; };
    if (window && 'onresize' in window) {
        window.onresize = setDimensions;
    }
    function setDimensions() {
        element.width = width();
        element.height = height();
    }
    setDimensions();
    var particles = new DecentralizedParticles(configOptions, particleOptions, segmentOptions);
    particles.beforeUpdate(function () {
        ctx.clearRect(0, 0, width(), height());
    });
    particles.createParticle(function (particle) {
        var img;
        if (isImage(particle.background)) {
            img = document.createElement('img');
            img.src = particle.background;
        }
        drawParticle(particle, img);
        particle.onUpdate(function () { return drawParticle(particle, img); });
    });
    particles.createSegment(function (segment) {
        drawSegment(segment);
        segment.onUpdate(function () { return drawSegment(segment); });
    });
    function drawParticle(particle, img) {
        if (img) {
            ctx.drawImage(img, particle.positionX * width(), particle.positionY * height(), particle.size, particle.size);
        }
        else {
            ctx.beginPath();
            ctx.arc(particle.positionX * width(), particle.positionY * height(), particle.size / 2, 0, 2 * Math.PI, false);
            ctx.fillStyle = particle.background;
            ctx.fill();
        }
    }
    function drawSegment(segment) {
        ctx.beginPath();
        ctx.moveTo(segment.positionX1 * width(), segment.positionY1 * height());
        ctx.lineTo(segment.positionX2 * width(), segment.positionY2 * height());
        ctx.strokeStyle = segment.stroke;
        ctx.lineWidth = segment.width;
        ctx.stroke();
    }
    function isImage(background) {
        var char1 = background.charAt(0);
        if (char1 === "." || char1 === "/")
            return true;
        if (/^data:image\//.test(background))
            return true;
        return false;
    }
    particles.start();
    return particles;
}

export { DecentralizedParticles, Particle, createParticlesOnCanvas };
//# sourceMappingURL=build.esm.js.map
